import React, { useState, useEffect, useRef, useMemo } from "react";
import "../profile/booking.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { delayData, websiteDetail } from "../../utils/common.data";
import { useBoardingDropping } from "../../context/BoardingDroppingContext";
import {
  addDaysToDateString,
  adjustToStartOfDayIfGreater,
  convertToUTC,
  handleRedirectUrl,
} from "../../utils/Functions";
// import BookingPageIcon from "../../assets/booking_view.jpg";
import BookingPageIcon from "../../assets/logo.png";
import AdminBookingPage from "./AdminBookingPage";
import "./style.css";
import { getTripDetail, getUserDetail } from "../../utils/api.functions";
import { useParams } from "react-router-dom";
import Loader from "../loader";
import moment from "moment";
import citiesJson from "../../utils/cities";
import { Autocomplete, TextField } from "@mui/material";

const AdminForm = () => {
  const params = useParams();
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);
  const today = dayjs();
  const fTime = today.add(0, "minute");
  const [myDate, setMyDate] = useState(fTime);
  const [err, setErr] = useState(false);
  const [address, setAddress] = useState("");
  const [drop, setDrop] = useState("");
    const [pickupLat, setPickupLat] = useState(null);
    const [pickupLng, setPickupLng] = useState(null);
    const [dropLat, setDropLat] = useState(null);
    const [dropLng, setDropLng] = useState(null);
  const [userid, setUserID] = useState("");
  const [bookingView, setBookingView] = useState(0);
  const [searchDetail, setSearchDetail] = useState({});
  const [userDetail, setUserDetail] = useState({});
  const [inputValue, setInputValue] = useState("");
  const [user, setUser] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [tripDetail, setTripDetail] = useState({});
  const [loader, setLoader] = useState(false);

  const { boardingDroppingPoints, fetchBoardingDroppingPoints,categoryTags,fetchCategoryTagsList } =
    useBoardingDropping();

  useEffect(() => {
    if (!boardingDroppingPoints) {
      fetchBoardingDroppingPoints(); // Fetch data if not already available
    }
  }, [boardingDroppingPoints, fetchBoardingDroppingPoints]);
  
    useEffect(() => {
      if (!categoryTags) {
        fetchCategoryTagsList(); // Fetch data if not already available
      }
    }, [categoryTags, fetchCategoryTagsList]);

  useEffect(() => {
    fetchBoardingDroppingPoints();
    fetchCategoryTagsList();
  }, []);

  useEffect(() => {
    getUserData();
  }, []);

  const handleDateAndTime = (newTime) => {
    if (newTime) {
      const startOfDay = newTime.isSame(dayjs(), "day")
        ? dayjs() // current day, use selected time
        : newTime.$d; // other date, set to start of day

      setMyDate(startOfDay);
    }
  };

  const onChangeAddress = (e) => {
      const data = citiesJson.find((city) => city.name === e.target.value);
      setAddress(e.target.value);
      setPickupLat(data?.lat || null);
      setPickupLng(data?.lng || null);
  };

  const onChangeDrop = (e) => {
      const data = citiesJson.find((city) => city.name === e.target.value);
      setDrop(e.target.value);
      setDropLat(data?.lat || null);
      setDropLng(data?.lng || null);
  };
  // Close dropdown if clicked outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !inputRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const Validation = () => {
    let result = true;

    if (
      address?.length == 0 ||
      drop?.length == 0 ||
      userid?.length == 0 ||
      address == null ||
      drop == null ||
      address == undefined ||
      drop == undefined ||
      dayjs(myDate).isBefore(dayjs(), "day")
    ) {
      result = false;
      setErr(true);
    }
    return result;
  };

  const detailHandler = (e) => {
    e.preventDefault();
    const startOfDay = dayjs(myDate).isSame(dayjs(), "day")
      ? dayjs() // current day, use selected time
      : myDate;
    if (Validation()) {
      const searchDetail = {
        boarding: address,
        dropping: drop,
        date: adjustToStartOfDayIfGreater(startOfDay),
        pickupLat: pickupLat,
        pickupLng: pickupLng, 
        dropLat: dropLat,
        dropLng: dropLng,
      };
      setSearchDetail(searchDetail);
      setBookingView(1);
      sessionStorage.setItem("bookingdetails", JSON.stringify(searchDetail));
    }
  };

  const handleBookingView = (val) => {
    if (val == 0 && Object.keys(searchDetail).length > 0) {
      setAddress(searchDetail?.boarding);
      setDrop(searchDetail?.dropping);
    }
    setMyDate(dayjs(new Date(searchDetail?.date || new Date())));
    setBookingView(val);
  };

  const getUserData = async () => {
    try {
      setLoader(true);
      const response = await getUserDetail(
        {},
        "786c5b910394360e27332ea1e88356be"
      );
      if (response.status === 200) {
        const value = response.data.resDecrypt.response;
        setUser(value);
        await getTripData();
        setLoader(false);
      }
    } catch (error) {
      console.log("User fetch ErrorError::", error);
      setLoader(false);
    }
  };

  const handleUserChange = (e) => {
    const userData = user.filter((value) => value.user_id == e.target.value);
    const userDetailValue = userData?.length > 0 ? userData[0] : {};
    // console.log({ userData })
    setUserID(e.target.value);
    setUserDetail(userDetailValue);
    setInputValue(`${userDetailValue?.u_name || userDetailValue?.u_phone}`);
    // console.log(`User Detail`,userDetailValue)
    const testdata = {
      key: "786c5b910394360e27332ea1e88356be",
      c_code: userDetailValue?.c_code,
      phone: userDetailValue?.u_phone,
      userid: userDetailValue?.user_id,
      fname: userDetailValue?.u_fname,
      lname: userDetailValue?.u_lname,
      email: userDetailValue?.u_email,
      name: userDetailValue?.u_name,
      city_id: userDetailValue?.city_id,
      city_cur: userDetailValue?.city_cur,
      wallet: userDetailValue?.u_wallet,
    };
    sessionStorage.setItem("key", "786c5b910394360e27332ea1e88356be");
    sessionStorage.setItem("code", testdata?.c_code);
    sessionStorage.setItem(
      "phone",
      "+" + testdata?.c_code + "" + testdata?.phone
    );
    sessionStorage.setItem("userid", testdata?.userid);
    sessionStorage.setItem("fname", testdata?.fname);
    sessionStorage.setItem("lname", testdata?.lname);
    sessionStorage.setItem("email", testdata?.email);
    sessionStorage.setItem("name", testdata?.name);
    sessionStorage.setItem("city_id", testdata?.city_id);
    sessionStorage.setItem("city_cur", testdata?.city_cur);
    sessionStorage.setItem(
      "wmt",
      userDetailValue?.u_wallet ? userDetailValue?.u_wallet : "0"
    );
    sessionStorage.setItem("auth", JSON.stringify(testdata));
    setShowDropdown(false);
  };

  const handleUserAdd = (userDetailValue) => {
    // const userData = user.filter((value) => value.user_id == e.target.value)
    // const userDetailValue = userData?.length > 0 ? userData[0] : {}
    // console.log({ userDetailValue })
    setUserID(userDetailValue?.user_id);
    setUserDetail(userDetailValue);
    setInputValue(`${userDetailValue?.u_name || userDetailValue?.u_phone}`);
    // console.log(`User Detail`,userDetailValue)
    const testdata = {
      key: "786c5b910394360e27332ea1e88356be",
      c_code: userDetailValue?.c_code,
      phone: userDetailValue?.u_phone,
      userid: userDetailValue?.user_id,
      fname: userDetailValue?.u_fname,
      lname: userDetailValue?.u_lname,
      email: userDetailValue?.u_email,
      name: userDetailValue?.u_name,
      city_id: userDetailValue?.city_id,
      city_cur: userDetailValue?.city_cur,
      wallet: userDetailValue?.u_wallet,
    };
    sessionStorage.setItem("key", "786c5b910394360e27332ea1e88356be");
    sessionStorage.setItem("code", testdata?.c_code);
    sessionStorage.setItem(
      "phone",
      "+" + testdata?.c_code + "" + testdata?.phone
    );
    sessionStorage.setItem("userid", testdata?.userid);
    sessionStorage.setItem("fname", testdata?.fname);
    sessionStorage.setItem("lname", testdata?.lname);
    sessionStorage.setItem("email", testdata?.email);
    sessionStorage.setItem("name", testdata?.name);
    sessionStorage.setItem("city_id", testdata?.city_id);
    sessionStorage.setItem("city_cur", testdata?.city_cur);
    sessionStorage.setItem(
      "wmt",
      userDetailValue?.u_wallet ? userDetailValue?.u_wallet : "0"
    );
    sessionStorage.setItem("auth", JSON.stringify(testdata));
    setShowDropdown(false);
  };

  const handleUserData = (data, value) => {
    if (!data) return [];
    if (value)
      return data.filter((userItem) => {
        const searchValue = value?.toLowerCase();
        return (
          userItem?.u_name?.toLowerCase().includes(searchValue) ||
          userItem?.u_fname?.toLowerCase().includes(searchValue) ||
          userItem?.u_lname?.toLowerCase().includes(searchValue) ||
          userItem?.u_phone?.toLowerCase().includes(searchValue) ||
          String(userItem?.user_id)?.toLowerCase().includes(searchValue)
        );
      });
    return data
      ?.filter((userItem) => userItem.user_id !== 1)
      ?.sort((a, b) => a.user_id - b.user_id);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    if (e.target.value?.length == 0) {
      setUserID("");
    }
  };

  const getTripData = async () => {
    // console.log({ params })
    if (params?.id) {
      try {
        setLoader(true);
        const response = await getTripDetail(
          {
            trip_id: params?.id,
          },
          "786c5b910394360e27332ea1e88356be"
        );
        if (response.status === 200) {
          let value = response.data.resDecrypt.response;
          if (Array.isArray(value) && value?.length > 0) {
            const tripValue = value[0];
            const customer_Details = JSON.parse(
              tripValue?.trip_customer_details
            );
            setTripDetail({
              ...tripValue,
              customer_details: customer_Details,
              drop_id: customer_Details?.dropping?.id,
              board_id: customer_Details?.boarding?.id,
            });
            setDrop(tripValue?.Category?.end_location);
            setAddress(tripValue?.Category?.start_location);
            setUserID(tripValue?.user_id);
            handleUserAdd(tripValue?.User);
                const startLocation = citiesJson.find((city) => city.name === tripValue?.Category?.start_location);
                const endLocation = citiesJson.find((city) => city.name === tripValue?.Category?.end_location);
setPickupLat(startLocation?.lat || null);
    setPickupLng(startLocation?.lng || null);
    setDropLat(endLocation?.lat || null);
    setDropLng(endLocation?.lng || null);
            const searchDetail = {
              boarding: tripValue?.Category?.start_location,
              dropping: tripValue?.Category?.end_location,
              date: adjustToStartOfDayIfGreater(
                dayjs(
                  convertToUTC(
                    addDaysToDateString(
                      moment(tripValue?.Category?.departure_date).format(
                        "HH:mm:ss"
                      ),
                      moment(convertToUTC(tripValue?.trip_date)).format(
                        "YYYY-MM-DD"
                      )
                    )
                  )
                )
              ),
              category_id: tripValue?.Category?.category_id,
              pickupLat: startLocation?.lat || null,
              pickupLng: startLocation?.lng || null, 
              dropLat: endLocation?.lat || null,
              dropLng: endLocation?.lng || null,
            };
            setSearchDetail(searchDetail);
            setBookingView(1);
            sessionStorage.setItem(
              "bookingdetails",
              JSON.stringify(searchDetail)
            );

            setLoader(false);
          } else {
            setTimeout(() => {
              handleRedirectUrl(
                `${process.env.REACT_APP_ADMIN_TRIP_SUCCESS_API}`,
                "_self"
              );
            }, delayData.adminFormDelay);
          }
        }
      } catch (error) {
        console.log("Trip fetch Error::", error);
        setTimeout(() => {
          handleRedirectUrl(
            `${process.env.REACT_APP_ADMIN_TRIP_SUCCESS_API}`,
            "_self"
          );
        }, delayData.adminFormDelay);
        setLoader(false);
      }
    }
  };

  const handleSortCity = (value) => {
    return value.sort((a, b) => a.name.localeCompare(b.name));
  };
  const uniqueCities = useMemo(() => {
    const seen = new Set();
    return handleSortCity(citiesJson).filter((city) => {
      if (seen.has(city.name)) return false;
      seen.add(city.name);
      return true;
    });
  }, [citiesJson]);

  return (
    <>
      {loader && <Loader classValue="loader_container_main_admin" />}
      {bookingView == 0 && (
        <div>
          <section className="tj-booking-frm admin_booking_form">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-6 booking_page_main">
                  <img
                    className="booking_page_main_image"
                    src={BookingPageIcon}
                    alt={websiteDetail.title}
                    title={websiteDetail.title}
                  />
                </div>
                <div className="col-md-6 col-sm-6 booking_select_form_main">
                  <div className="tab-content">
                    <div className="tab-pane active" id="point">
                      <form
                        onSubmit={detailHandler}
                        className="booking-frm"
                        id="User-Form"
                      >
                        <div className="col-md-12 col-sm-12">
                          <strong
                            style={{
                              marginTop: "10px",
                              marginBottom: "-10px",
                            }}
                          >
                            User
                          </strong>
                          <div className="field-holder border padding-input">
                            {/* <select
                                                        id="users"
                                                        value={userid}
                                                        onChange={handleUserChange}
                                                        className="dropdown_main_select"
                                                    >
                                                        <option value="">
                                                        <input
                    placeholder="Search user"
                    value={inputValue}
                    onChange={handleInputChange}
                />
                                                        </option>
                                                        {handleUserData(user, inputValue).map((userItem) => (
                                                            <option key={userItem?.user_id} value={userItem?.user_id}>
                                                                {`${userItem?.user_id}-${userItem?.u_name?userItem?.u_name:userItem?.u_phone}`}
                                                            </option>
                                                        ))}
                                                    </select> */}
                            <div className="relative">
                              <input
                                ref={inputRef}
                                type="text"
                                className="admin_booking_form_dropdown_input"
                                placeholder="Search user..."
                                value={inputValue}
                                onChange={handleInputChange}
                                onFocus={() => setShowDropdown(true)}
                              />

                              {showDropdown && (
                                <ul
                                  ref={dropdownRef}
                                  className="admin_booking_form_dropdown"
                                >
                                  {handleUserData(user, inputValue).length >
                                  0 ? (
                                    handleUserData(user, inputValue).map(
                                      (userItem) => (
                                        <li
                                          key={userItem.user_id}
                                          className={`admin_booking_form_dropdown_menu ${
                                            userid == userItem.user_id
                                              ? "admin_booking_form_dropdown_menu_selected"
                                              : ""
                                          }`}
                                          onClick={() =>
                                            handleUserChange({
                                              target: {
                                                value: userItem.user_id,
                                              },
                                            })
                                          }
                                        >
                                          {`${userItem.user_id} - ${
                                            userItem.u_name || userItem.u_phone
                                          }`}
                                        </li>
                                      )
                                    )
                                  ) : (
                                    <li className="p-2 text-gray-500">
                                      No results found
                                    </li>
                                  )}
                                </ul>
                              )}
                            </div>

                            {err && userid?.length <= 0 ? (
                              <label
                                htmlFor="u_email"
                                id="u_email-error"
                                className="error form_validation_err"
                                style={{
                                  color: "#e74c3c",
                                  fontWeight: "500",
                                  fontSize: "15px",
                                }}
                              >
                                Select User
                              </label>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-12 col-sm-12">
                          <strong
                            style={{
                              marginTop: "10px",
                              marginBottom: "-10px",
                            }}
                          >
                            From
                          </strong>
                          <div className="field-holder border padding-input">
                            <Autocomplete
                                                            options={uniqueCities}
                                                            getOptionLabel={(option) => {
                                                              return option.name ?? "";
                                                            }}
                                                            value={
                                                              uniqueCities.find(
                                                                (city) => city.name === address
                                                              ) || null
                                                            }
                                                            onChange={(event, newValue) => {
                                                              onChangeAddress({
                                                                target: { value: newValue?.name || null },
                                                              });
                                                            }}
                                                            filterOptions={(options, { inputValue }) =>
                                                              options.filter((option) =>
                                                                option.name
                                                                  .toLowerCase()
                                                                  .includes(inputValue.toLowerCase())
                                                              )
                                                            }
                                                            renderInput={(params) => (
                                                              <TextField
                                                                key={params.id}
                                                                {...params}
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                                placeholder="Enter From Location"
                                                                className="admin_booking_form_dropdown_input_textfield"
                                                              />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => {
                                                              // console.log({option},value)
                                                              return option.name === value;
                                                            }}
                                                          />
                            {/* <select
                              id="boardingPoints"
                              value={address}
                              onChange={onChangeAddress}
                              className="dropdown_main_select"
                            >
                              <option value="">Select From Location</option>
                              {boardingDroppingPoints?.boarding?.map(
                                (value) => (
                                  <option key={value} value={value}>
                                    {value}
                                  </option>
                                )
                              )}
                            </select> */}

                            {err && (address?.length <= 0 || !address) ? (
                              <label
                                htmlFor="u_email"
                                id="u_email-error"
                                className="error form_validation_err"
                                style={{
                                  color: "#e74c3c",
                                  fontWeight: "500",
                                  fontSize: "15px",
                                }}
                              >
                                Select From Location
                              </label>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12">
                          <strong
                            style={{
                              marginTop: "10px",
                              marginBottom: "-10px",
                            }}
                          >
                            To
                          </strong>
                          <div className="field-holder border">
                            {/* <select
                              id="droppingPoints"
                              value={drop}
                              onChange={onChangeDrop}
                              className="dropdown_main_select"
                            >
                              <option
                                className="dropdown_main_select_option"
                                value=""
                              >
                                Select To Location
                              </option>
                              {boardingDroppingPoints?.dropping?.map(
                                (value) => (
                                  <option
                                    className="dropdown_main_select_option"
                                    key={value}
                                    value={value}
                                  >
                                    {value}
                                  </option>
                                )
                              )}
                            </select> */}
                            <Autocomplete
                                                            options={uniqueCities}
                                                            getOptionLabel={(option) => {
                                                              return option.name ?? "";
                                                            }}
                                                            value={
                                                              uniqueCities.find(
                                                                (city) => city.name === drop
                                                              ) || null
                                                            }
                                                            onChange={(event, newValue) => {
                                                              onChangeDrop({
                                                                target: { value: newValue?.name || null },
                                                              });
                                                            }}
                                                            filterOptions={(options, { inputValue }) =>
                                                              options.filter((option) =>
                                                                option.name
                                                                  .toLowerCase()
                                                                  .includes(inputValue.toLowerCase())
                                                              )
                                                            }
                                                            renderInput={(params) => (
                                                              <TextField
                                                                key={params.id}
                                                                {...params}
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                                placeholder="Enter To Location"
                                                                className="admin_booking_form_dropdown_input_textfield"
                                                              />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => {
                                                              // console.log({option},value)
                                                              return option.name === value;
                                                            }}
                                                          />
                            {err && (drop?.length <= 0 || !drop) && (
                              <label
                                htmlFor="u_email"
                                id="u_email-error"
                                className="error form_validation_err"
                                style={{
                                  color: "#e74c3c",
                                  fontWeight: "500",
                                  fontSize: "15px",
                                }}
                              >
                                Select To Location
                              </label>
                            )}
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12">
                          <strong
                            style={{
                              marginTop: "10px",
                              marginBottom: "-10px",
                            }}
                          >
                            Date
                          </strong>
                          <div className="field-holder">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DesktopDatePicker
                                value={myDate}
                                className="common_form_date_picker"
                                disablePast
                                onChange={(e) => handleDateAndTime(e)}
                                slotProps={{
                                  textField: {
                                    error: false,
                                    inputProps: {
                                      readOnly: true,
                                      tabIndex: -1,
                                    },
                                  },
                                }}
                                format="DD/MM/YYYY"
                                disableOpenOnEnter={true} // Disables manual opening by clicking the input field
                              />
                            </LocalizationProvider>
                          </div>
                          {err && dayjs(myDate).isBefore(dayjs(), "day") ? (
                            <label
                              htmlFor="u_email"
                              id="u_email-error"
                              className="error form_validation_err"
                              style={{
                                color: "#e74c3c",
                                fontWeight: "500",
                                fontSize: "11px",
                                marginTop: "-10px",
                                marginBottom: "8px",
                              }}
                            >
                              Please select a future date
                            </label>
                          ) : null}
                        </div>
                        <div className="col-md-12 col-sm-12">
                          <button className="book-btn common_booking_button common_button_border">
                            Search{" "}
                            <i
                              className="fas fa-arrow-circle-right"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
      {bookingView == 1 && (
        <AdminBookingPage
          searchDetail={searchDetail}
          tripDetail={Object.keys(tripDetail).length > 0 ? tripDetail : null}
          handleView={() => {
            handleBookingView(0);
          }}
        />
      )}
    </>
  );
};

export default AdminForm;
